//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObject.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
let d=[[[0,"AbsXValue",1,0],[0,"AbsYValue",1,0],[0,"AbsZValue",1,0],[0,"CreateByCoordinates",1,0],[0,"CreateCoordSymbol",1,0],[0,"CreatePmiWithLeader",1,0],[0,"DeltaX",1,0],[0,"DeltaY",1,0],[0,"DeltaZ",1,0],[0,"OutputToInformation",1,0],[0,"Point",1,"Point",0],[0,"PointSymbolType",1,0],[0,"PortName",1,0],[1,"RoutingComponent",0,"SelectDisplayableObject",0],[0,"SelectionType",1,0],[0,"Type",1,0],[0,"XDirection",1,0],[0,"XDistance",1,0],[0,"XFrameOption",1,0],[0,"XValueLabel",1,0],[0,"YDirection",1,0],[0,"YDistance",1,0],[0,"YFrameOption",1,0],[0,"YValueLabel",1,0],[0,"ZDirection",1,0],[0,"ZDistance",1,0],[0,"ZFrameOption",1,0],[0,"ZValueLabel",1,0]],[[[],"CycleRoutingPorts",{},0,0],[[],"CreatePointByCoordinates",{},0,0],[["position"],"SetPosition",{},1,0],[["num_ports","ports"],"GetPorts",{},0,0],[["portIndex"],"EvaluateSinglePortInformation",{},1,0],[["position"],"EvaluatePointInformation",{},1,0],[["tgView"],"SetPointSelectionView",{},1,0],[["port"],"SetCurrentDisplayPort",{},1,0],[[],"AppendPointToInformation",{},0,0],[["pointTag","targetView","labelType"],"CreatePMILabelInModel",{R_:{pmiNote:"Annotations.PmiNote"}},3,0]],[]];
SPLM.Features.ShipDesign.ShipCoordinatesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ShipCoordinatesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ShipCoordinatesBuilder.Selection = Object.freeze({
    "Point" : "Point", "Component" : "Component"});

SPLM.Features.ShipDesign.ShipCoordinatesBuilder.XDirectionType = Object.freeze({
    "Forward" : "Forward", "Aft" : "Aft"});

SPLM.Features.ShipDesign.ShipCoordinatesBuilder.YDirectionType = Object.freeze({
    "Port" : "Port", "Starboard" : "Starboard"});

SPLM.Features.ShipDesign.ShipCoordinatesBuilder.ZDirectionType = Object.freeze({
    "Above" : "Above", "Below" : "Below"});

SPLM.Features.ShipDesign.ShipCoordinatesBuilder.SymbolType = Object.freeze({
    "ShipAbsoluteCoordinate" : "ShipAbsoluteCoordinate", "ShipGridCoordinate" : "ShipGridCoordinate"});

export default SPLM;